import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import Repo from "../../Utility/Repo";
import Loader from "../../Components/Loader";
import ModalComponent from "../../Components/ModalComponent";
import { TokenContext } from "../../Components/TokenContext";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

function DettaglioIscrizione(props) {
  const apiToken = useContext(TokenContext);

  const { iscrizioneId } = useParams();

  const [loading, setLoading] = useState(true);
  const [domanda, setDomanda] = useState(null);
  const [isOpenRefuseUser, toggleRefuseUserModal] = useState(false);
  const id = new URLSearchParams(location.search).get("id");

  useEffect(() => {
    loadDomanda();
  }, []);

  const loadDomanda = async () => {
    try {
      const response = await Repo.getExcelByIscrizione(apiToken, iscrizioneId);

      const domanda = {
        ...response.data,
        data: JSON.parse(response.data.data),
      };

      console.log(domanda);

      setDomanda(domanda);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const confirmUser = async () => {
    try {
      await Repo.postConfirmUser(apiToken, {
        id: id,
        state: 3,
      });

      toggleRefuseUserModal(false);

      // eventualmente ricarica
      loadDomanda();

      // oppure torna indietro
      // window.history.back();
    } catch (err) {
      console.log(err);
      alert("Errore durante il rifiuto dell'iscrizione");
    }
  };

  const dettaglioOriginaleUrl =
    `${process.env.REACT_APP_ISTANZE}` +
    `/lista_servizi/dettaglio_servizio/dettaglio_versione_servizio/iscrizioni/dettaglio?id=${iscrizioneId}`;

  return (
    <>
      <div>
        <h1>Dettaglio domanda</h1>

        <div className="row">
          <div className="clearfix col-6 py-lg-2">
            <p>
              Visualizzazione dei dati acquisiti durante la presentazione della
              domanda.
            </p>
          </div>
          <div className="col-lg-6 col-md-12 text-right">
            <button
              type="button"
              className="btn rounded btn-outline-danger btn-xs"
              title="Rifiuta"
              onClick={() => toggleRefuseUserModal(true)}
            >
              <svg className="icon icon-danger">
                <use href={`${iconSprite}#it-close`} />
              </svg> Rifiuta
            </button>

            <a
              href={`${process.env.REACT_APP_ISTANZE}/lista_servizi/dettaglio_servizio/dettaglio_versione_servizio/iscrizioni/dettaglio?id=${iscrizioneId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-primary m-2 btn-xs"
            >
              <svg className="icon icon-primary mr-1">
                <use href={`${iconSprite}#it-external-link`} />
              </svg>
              Apri domanda originale
            </a>

            <button
              type="button"
              className="btn btn-outline-primary m-2 btn-xs"
              onClick={() => window.history.back()}
            >
 <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-arrow-left`} />
              </svg> Indietro

            
            </button>
          </div>
        </div>

        <div className="container">
          {domanda ? (
            <div className="card card-bg no-after card-big roundedCustom">
              <div className="card-body">
                {Object.entries(domanda.data).map(([key, value]) => (
                  <div key={key} className="row border-bottom py-2">
                    <div className="col-md-4">
                      <strong>{key}</strong>
                    </div>

                    <div className="col-md-8">{value ?? "—"}</div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="text-center py-3">
              <b>Nessun dato disponibile.</b>
            </div>
          )}
        </div>
      </div>

      {loading && <Loader />}
      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={toggleRefuseUserModal}
        isOpen={isOpenRefuseUser}
        header="Iscrizione utente"
        body="Confermi di voler rifiutare l'iscrizione?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={confirmUser}
      />
    </>
  );
}

export default DettaglioIscrizione;
